module.exports = __webpack_public_path__ + "img/12_10.80da1639.png";